<template>
  <StandardResourceService
    title="迪士尼产品配置"
    v-model="activeTab"
    :tab-list="tabList">
    <ProductConfigComponent v-if="activeTab === 'productConfig'" />
    <!-- <GlobalMarkupComponent v-else-if="activeTab === 'globalMarkup'" /> -->
    <RelatedAccountsComponent v-else-if="activeTab === 'relatedAccounts'" />
  </StandardResourceService>
</template>

<script>
import StandardResourceService from '@/customComponents/standard/StandardResourceService.vue'
import ProductConfigComponent from './components/ProductConfigComponent.vue'
// import GlobalMarkupComponent from './components/GlobalMarkupComponent.vue'
import RelatedAccountsComponent from './components/RelatedAccountsComponent.vue'

export default {
  name: 'DisneyProductConfig',
  components: {
    StandardResourceService,
    ProductConfigComponent,
    // GlobalMarkupComponent,
    RelatedAccountsComponent
  },
  data() {
    return {
      activeTab: 'productConfig',
      tabList: [
        { label: '迪士尼产品配置', key: 'productConfig' },
        // { label: '全局加价管理', key: 'globalMarkup' },
        { label: '关联账户', key: 'relatedAccounts' }
      ]
    }
  }
}
</script>

<style scoped lang="less">
</style>
